import { render, staticRenderFns } from "./Experimente.vue?vue&type=template&id=32512cc0&"
import script from "./Experimente.vue?vue&type=script&lang=js&"
export * from "./Experimente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports